import { localStorageWrapper } from './local-stoarage-wrapper';

export const local = localStorageWrapper(() => localStorage);

export { localStorageWrapper };
